import { faker } from '@faker-js/faker/locale/en'
import Link from 'next/link'

import * as S from './styles'
import { useWorkWithUs } from './useWorkWithUs'
import { Text } from '@/components'
import { Button } from '@/components/button'
import { WorkWithUs } from '@/service/api/culturePage/types'

export type WorkWithUsContainerProps = {
  data: WorkWithUs
}

export const WorkWithUsContainer: React.FC<WorkWithUsContainerProps> = ({
  data,
}) => {
  const { imageData, responsiveness } = useWorkWithUs(data)

  return (
    <S.WorkWithUsContainer>
      <Text
        size={responsiveness.title}
        color="black"
        align="center"
        className="title"
      >
        {data?.title}
      </Text>
      <Link href={data?.button.url} passHref target="_blank">
        <Button>{data?.button.text}</Button>
      </Link>
      <div className="image-container">
        <S.TopRowImageContainer>
          {imageData
            .slice(0, responsiveness.images.numberOfImagesShown / 2)
            .map((ref) => (
              <div key={faker.datatype.uuid()} ref={ref} />
            ))}
        </S.TopRowImageContainer>
        <S.BottomRowImageContainer>
          {imageData
            .slice(responsiveness.images.numberOfImagesShown / 2)
            .map((ref) => (
              <div key={faker.datatype.uuid()} ref={ref} />
            ))}
        </S.BottomRowImageContainer>
      </div>
    </S.WorkWithUsContainer>
  )
}
